module.exports = __webpack_public_path__ + "img/26.2be6927a.png";